<script setup>
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { dynamicTime, shortTimestamp } from 'shared/helpers/timeHelper';
import { conversationUrl } from 'dashboard/helper/URLHelper.js';

import Avatar from 'dashboard/components-next/avatar/Avatar.vue';

const props = defineProps({
  conversation: {
    type: Object,
    required: true,
  },
  isMoving: {
    type: Boolean,
    default: false,
  },
});

const route = useRoute();
const router = useRouter();

const sender = computed(() => props.conversation.meta?.sender || {});
const senderName = computed(() => sender.value.name || sender.value.email || '—');

const lastMessagePreview = computed(() => {
  const message = props.conversation.last_non_activity_message;
  return message?.content || '';
});

const lastActivityAt = computed(() => {
  const { timestamp } = props.conversation;
  return timestamp ? shortTimestamp(dynamicTime(timestamp)) : '';
});

const openConversation = () => {
  router.push(
    conversationUrl({
      accountId: route.params.accountId,
      id: props.conversation.id,
    })
  );
};
</script>

<template>
  <div
    class="flex flex-col gap-2 p-3 bg-n-solid-1 border border-n-weak rounded-lg cursor-grab active:cursor-grabbing hover:border-n-slate-6 transition-colors"
    :class="{ 'opacity-60 pointer-events-none': isMoving }"
    @click="openConversation"
  >
    <div class="flex items-center gap-2">
      <Avatar :src="sender.thumbnail" :name="senderName" :size="24" rounded-full />
      <span class="text-sm font-medium text-n-slate-12 truncate">
        {{ senderName }}
      </span>
      <span class="ml-auto text-xs text-n-slate-9 shrink-0">
        {{ lastActivityAt }}
      </span>
    </div>
    <p v-if="lastMessagePreview" class="text-xs text-n-slate-11 line-clamp-2">
      {{ lastMessagePreview }}
    </p>
    <span class="text-xs text-n-slate-9">#{{ conversation.id }}</span>
  </div>
</template>
